/*
 * cart-fly.js — keeps the cart drawer in sync without a page refresh, plus a
 * fly-to-cart animation. Does NOT add to cart itself (the theme does that);
 * it refreshes + opens the drawer after any cart change.
 */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer#CartDrawer'); }

  function replaceRegion(prefix) {
    var el = document.querySelector('[id^="' + prefix + '"]');
    if (!el) return Promise.resolve();
    var id = el.id.slice(prefix.length);
    return fetch(ROOT + '?section_id=' + encodeURIComponent(id), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(prefix + id);
        var cur = document.getElementById(prefix + id);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function updateCounts() {
    return fetch(ROOT + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('cart-count').forEach(function (n) {
          n.textContent = c.item_count;
          if (c.item_count > 0) { n.removeAttribute('hidden'); } else { n.setAttribute('hidden', ''); }
        });
      })
      .catch(function () {});
  }

  function openDrawer() {
    var d = drawer();
    if (d && typeof d.show === 'function' && !d.open) {
      try { d.show(); } catch (e) {}
    }
  }

  /* Refresh the visible cart. `open` opens the drawer when done. No persistent
     lock — a short debounce prevents duplicate work but can never get stuck. */
  var pending = null;
  function sync(open) {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () {
      pending = null;
      Promise.all([replaceRegion('MiniCart-'), replaceRegion('MainCart-'), updateCounts()])
        .then(function () { if (open) openDrawer(); })
        .catch(function () {});
    }, 60);
  }

  function biggestVisibleImage() {
    var best = null, area = 0;
    document.querySelectorAll('img').forEach(function (im) {
      var r = im.getBoundingClientRect();
      if (r.width < 60 || r.top > window.innerHeight || r.bottom < 0) return;
      var a = r.width * r.height;
      if (a > area) { area = a; best = im; }
    });
    return best;
  }

  function flyToCart(originEl) {
    var cartIcon = document.querySelector('.cart-drawer-button') || document.querySelector('[aria-controls="CartDrawer"]');
    if (cartIcon) cartIcon.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.28)' }, { transform: 'scale(1)' }], { duration: 520, easing: 'ease-out' });
    var img = (originEl && originEl.querySelector && originEl.querySelector('img')) || biggestVisibleImage();
    if (!img || !cartIcon) return;
    var r1 = img.getBoundingClientRect(), r2 = cartIcon.getBoundingClientRect();
    if (!r1.width) return;
    var clone = img.cloneNode(true);
    clone.style.cssText = 'position:fixed;z-index:99999;left:' + r1.left + 'px;top:' + r1.top + 'px;width:' + r1.width + 'px;height:' + r1.height +
      'px;border-radius:14px;object-fit:cover;pointer-events:none;box-shadow:0 12px 40px -8px rgba(236,72,153,.7);' +
      'transition:left .8s cubic-bezier(.5,-0.4,.3,1.2),top .8s cubic-bezier(.5,-0.4,.3,1.2),width .8s ease,height .8s ease,opacity .8s ease,transform .8s ease;';
    document.body.appendChild(clone);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      clone.style.left = (r2.left + r2.width / 2 - 14) + 'px';
      clone.style.top = (r2.top + r2.height / 2 - 14) + 'px';
      clone.style.width = '28px'; clone.style.height = '28px'; clone.style.opacity = '0.25'; clone.style.transform = 'rotate(18deg)';
    }); });
    setTimeout(function () { clone.remove(); }, 880);
  }

  function isAddButton(el) {
    var btn = el.closest && el.closest('[name="add"], [type="submit"]');
    if (!btn) return null;
    var form = btn.form || btn.closest('form');
    if (!form || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return null;
    return btn;
  }

  /* Animate + refresh on add-to-cart click (fallback if events don't fire). */
  document.addEventListener('click', function (e) {
    var btn = isAddButton(e.target);
    if (!btn) return;
    var origin = btn.closest('product-form, .product, .product__info, .product-card, .card, [class*="product"]') || document;
    flyToCart(origin);
    setTimeout(function () { sync(true); }, 700);
  }, true);

  /* Primary: theme fires this after a successful add. */
  document.addEventListener('ajaxProduct:added', function () { sync(true); });
  /* Any other cart change (quantity, remove, discount, fee) — refresh, don't force-open. */
  document.addEventListener('cart:updated', function () { sync(false); });
})();
